/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";
import L from "./Lang"
import BaseCom from "./BaseCom";
import Icon from "./Icon";
import { SidebarGlobal } from "./_Sidebar";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import Card from "./Card";
import FormInput from "./FormInput";
import Auth from "../shared/Auth";
import { qreq } from "../shared/qrequest";
import AppActions from "./AppActions";

class Settings extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            info: {}
        };
        this.submitRef = React.createRef();
        this.load = this.load.bind(this);
        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        Auth.getLogin(u => {
            if (!u || u.roles.indexOf('admin') === -1) {
                this.alert('You do not have permission to view this page');
                setTimeout(() => this.props.navigate('/'), 100);
            }
            this.setState({ user: u });
            this.load();
        });
        SidebarGlobal.setSubNav(<><button type="button" className="btn btn-success" onClick={() => this.submitRef.current?.click()}><Icon icon="faSave" /> <L>Save</L></button></>);
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    load() {
        qreq.get('/api/settings/get', j => {
            if (j.item) {
                this.setState({ info: j.item });
            }
            else
                this.alert(j.errorMessage);
        }, this.unkownErrorCallback);
    }

    submit(e) {
        e?.preventDefault();
        var info = { ...this.state.info };
        qreq.post('/api/settings/set', info, j => {
            if (j.errorCode === 0)
                this.success('Settings saved successfully');
            else
                this.alert(j.errorMessage);
        }, this.unkownErrorCallback);
    }

    render() {
        return <div className="container-fluid">
            <h1><L>Settings</L></h1>
            <form onSubmit={this.submit}>
                <AppActions>
                    <button type="submit" className="btn btn-success btn-lg"><Icon icon="faSave" /> <L>Save</L></button>
                </AppActions>
                <Card title="Approval Requirements">
                    <FormInput model={this.state.info} label="Service Approvals Required" name="serviceApprovalsRequired" type="number" />
                    <FormInput model={this.state.info} label="Clinical Approvals Required" name="clinicalApprovalsRequired" type="number" />
                </Card>

                <button type="submit" ref={this.submitRef} style={{ display: 'none' }}></button>
            </form>
        </div>;
    }
}

export default withParamsAndNavigate(Settings);